// extracted by mini-css-extract-plugin
module.exports = {"shortcuts":"shortcuts_shortcuts__32SMs","active":"shortcuts_active__1OTX1"};